import React, { useState } from "react";
import { Box } from "@material-ui/core";
import clsx from "clsx";
import { useDeviceTypes } from "halifax";
import { RouteComponentProps } from "react-router";
import { FlightShopStep } from "redmond";
import { FlightShopSummaryPanelConnectorProps } from "./container";
import "./styles.scss";
import { getSliceIndex } from "../../../../../../utils/flights";
import { FlightReviewDetailsPopover, FlightSummaryPanel } from "./components";
import { ChangeItineraryModal } from "../../../ChangeItineraryModal";

export type IVirtualInterliningVariant =
  | "selfCheck"
  | "missedConnectionProtection"
  | "missedConnectionGuarantee";

export interface IFlightShopSummaryPanelProps
  extends FlightShopSummaryPanelConnectorProps,
    RouteComponentProps {
  // note: when both are set to true, nothing would be shown
  showDepartureReviewOnly?: boolean;
  showReturnReviewOnly?: boolean;
  showViewDetailsSection?: boolean;
  disableChangeFlight?: boolean;
  // isSeatsUXOptimizationExperiment?: boolean;
  // isVITripSelected: boolean;
  // setOpenVIVariantModal: (variant: IVirtualInterliningVariant) => void;
  // setOpenMultipleAirlinesFares: (value: boolean) => void;
}

const defaultProps: Partial<IFlightShopSummaryPanelProps> = {
  disableChangeFlight: false,
  showDepartureReviewOnly: false,
  showReturnReviewOnly: false,
  showViewDetailsSection: false,
  // isSeatsUXOptimizationExperiment: false,
};

export const FlightShopSummaryPanel = (props: IFlightShopSummaryPanelProps) => {
  const {
    tripDetails,
    fareDetails,
    showDepartureReviewOnly,
    showReturnReviewOnly,
    showViewDetailsSection,
    airports,
    // isOutgoingMultiTicket,
    disableChangeFlight,
    // isSeatsUXOptimizationExperiment,
    // isVITripSelected,
    // setOpenVIVariantModal,
    // setOpenMultipleAirlinesFares,
    history,
    setPackagesFlightShopProgress,
  } = props;
  const { matchesMobile } = useDeviceTypes();
  const [openChangeOutboundFlightModal, setOpenChangeOutboundFlightModal] =
    useState(false);

  const handleChangeOutboundFlight = () => {
    if (!disableChangeFlight) setOpenChangeOutboundFlightModal(true);
  };

  const handleChangeReturnFlight = () => {
    setPackagesFlightShopProgress(FlightShopStep.ChooseReturn);
    history.goBack();
  };

  const hasDepartureFlight = getSliceIndex(true, tripDetails) !== -1;
  const hasReturnFlight = getSliceIndex(false, tripDetails) !== -1;

  const showDepartureFlight = hasDepartureFlight && !showReturnReviewOnly;
  const showReturnFlight = hasReturnFlight && !showDepartureReviewOnly;

  return (
    <Box
      className={clsx("pkg-review-flight-shop-summary-panel-root", {
        mobile: matchesMobile,
      })}
    >
      <Box className="flight-shop-summary-panel-container">
        <Box
          className={clsx("itinerary-cards-section", {
            "only-display-one":
              (showDepartureFlight && !showReturnFlight) ||
              (!showDepartureFlight && showReturnFlight),
          })}
        >
          {showDepartureFlight && (
            <Box
              className={clsx("flight-shop-summary-panel-card", "departure", {
                mobile: matchesMobile,
              })}
            >
              <FlightSummaryPanel
                departure
                tripDetails={tripDetails}
                airports={airports}
              />
              {showViewDetailsSection && fareDetails && (
                <FlightReviewDetailsPopover
                  departure
                  tripDetails={tripDetails}
                  fareDetails={fareDetails}
                  isMobile={matchesMobile}
                  onClickEdit={handleChangeOutboundFlight}
                  airports={airports}
                  // isVITripSelected={isVITripSelected}
                  // setOpenVIVariantModal={setOpenVIVariantModal}
                  // setOpenMultipleAirlinesFares={setOpenMultipleAirlinesFares}
                  disableChangeFlight={disableChangeFlight}
                />
              )}
            </Box>
          )}
          {showReturnFlight && (
            <Box
              className={clsx("flight-shop-summary-panel-card", "return", {
                mobile: matchesMobile,
              })}
            >
              <FlightSummaryPanel
                departure={false}
                tripDetails={tripDetails}
                airports={airports}
              />

              {showViewDetailsSection && fareDetails && (
                <FlightReviewDetailsPopover
                  departure={false}
                  tripDetails={tripDetails}
                  fareDetails={fareDetails}
                  isMobile={matchesMobile}
                  onClickEdit={handleChangeReturnFlight}
                  airports={airports}
                  disableChangeFlight={disableChangeFlight}
                />
              )}
            </Box>
          )}
        </Box>
      </Box>

      {openChangeOutboundFlightModal && (
        <ChangeItineraryModal
          type="outbound-flight"
          openModal={openChangeOutboundFlightModal}
          setOpenModal={setOpenChangeOutboundFlightModal}
          isMobile={matchesMobile}
        />
      )}
    </Box>
  );
};

FlightShopSummaryPanel.defaultProps = defaultProps;
